import base from './base.repository';

export default {
	...base,
	getPersonVisits(personId, filters, page = 1) {
		const params = {
			...filters,
			page: page,
			person: personId
		};
		return this.get(`person-entries${this.querify(params)}`);
	},
	getVisitorTypes() {
		return this.get('vigilance/visitor-types');
	}
};



// WEBPACK FOOTER //
// ./src/repositories/visits.repository.js